import { Check } from 'lucide-react';
import styles from './StepCircle.module.css';

export function StepCircle({ n, done }: { n: number; done: boolean }) {
  return (
    <div className={`${styles.circle} ${done ? styles.circleDone : ''}`}>
      {done ? <Check size={14} strokeWidth={2.5} /> : n}
    </div>
  );
}
